const constants = {
  USER_STORE_MODULE_NAME: 'featureUser',

  EVENT_CONTACT_UPDATED: 'event-contact-updated',
  EVENT_CONTACT_ADDED: 'event-contact-added',
}
export default constants
